import { render, staticRenderFns } from "./pending-approval.vue?vue&type=template&id=08b2a4e0&scoped=true&"
import script from "./pending-approval.vue?vue&type=script&lang=js&"
export * from "./pending-approval.vue?vue&type=script&lang=js&"
import style0 from "./pending-approval.vue?vue&type=style&index=0&id=08b2a4e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b2a4e0",
  null
  
)

export default component.exports